module.exports = __webpack_public_path__ + "img/gengduoyingyong.83ecc640.png";